export class LabelUtils {
 public getSentimentType(SentimentType: string) {
  switch (SentimentType) {
   case 'Positive':
    return 'p'
    break
   case 'Neutral':
    return 'n'
    break
   case 'Negative':
    return 'v'
    break
   case 'Not Rated':
    return 'u'
    break
   default:
    break
  }
 }

 emotionalComparisonFormatter({ key }) {
  switch (key) {
   case 'Joy':
    return `<span style="font-size: 1.3rem;">😊</span>`
    break
   case 'Fear':
    return `<span style="font-size: 1.3rem;">😰</span>`
    break
   case 'Disgust':
    return `<span style="font-size: 1.3rem;">🤢</span>`
    break
   case 'Surprise':
    return `<span style="font-size: 1.3rem;">😲</span>`
    break
   case 'Happiness':
    return `<span style="font-size: 1.3rem;">😄</span>`
    break
   case 'Anger':
    return `<span style="font-size: 1.3rem;">😠</span>`
    break
   case 'Love':
    return `<span style="font-size: 1.3rem;">❤️️</span>`
    break
   case 'Sadness':
    return `<span style="font-size: 1.3rem;">😔</span>`
    break
   case 'Hatred':
    return `<span style="font-size: 1.3rem;">😡</span>`
    break
   case 'Excitement':
    return `<span style="font-size: 1.3rem;">😆</span>`
    break
   default:
    break
  }
 }

 compareVertBarFormatter = ({ key, value }) => {
  return `<span style="font-size: 1.3rem;">${this.numberTransform(value)}</span>`
 }

 numberTransform(input: number): string {
  let roundedInput: number = Math.round(input)
  let truncatedNumber: number
  let fixedNumber: String
  let numberKey: String = ''
  let dotIndex: Number

  if (input === null || isNaN(roundedInput)) {
   return '-'
  }

  if (roundedInput === 0 || roundedInput === -0) {
   return '0'
  }

  if (Math.abs(roundedInput) >= this.BaseNumbers.E) {
   return `${roundedInput}`
  }

  for (let key of Object.keys(this.BaseNumbers)) {
   if (Math.abs(roundedInput) >= this.BaseNumbers[key]) {
    truncatedNumber = roundedInput / this.BaseNumbers[key]
    numberKey = key
    break
   }
  }

  dotIndex = Math.abs(truncatedNumber)
   .toString()
   .indexOf('.')

  if (dotIndex === 1) {
   fixedNumber = truncatedNumber.toFixed(2)
  } else if (dotIndex === 2) {
   fixedNumber = truncatedNumber.toFixed(1)
  } else {
   fixedNumber = truncatedNumber.toFixed(0)
  }

  // localize the number via angular number pipe and append number key before returning
  return `${fixedNumber} ${numberKey}`
 }

 BaseNumbers = {
  E: 1000000000000000000, // quintillion
  Q: 1000000000000000, // quadrillion, standard symbol is 'P'
  T: 1000000000000, // trillion
  B: 1000000000, // billion, standard symbol is 'G'
  M: 1000000, // million
  k: 1000, // thousand
  '': 1,
 }
}
